export class User {
    public id: string;
    public email: string;
    public password: string;

    constructor() {
    }
}
